
export default {

    checkBoxSvg: function() {

        return `<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n" +
                                               "        <defs>\n" +
                                               " <clipPath id=\"clip-Arrow_Down_Red\">\n" +
                                              "                <rect width=\"24\" height=\"24\"/>\n" +
                                         "  </clipPath>\n" +
                                    "        </defs>\n" +
                                              " <g id="Check_Box_Checked" clip-path="url(#clip-Check_Box_Checked)">\n" +
                                                "<rect width=\"24\" height=\"24\" fill=\"rgba(81,91,96,0)\"/>\n" +
                                                "<g id=\"Group_13316\" data-name=\"Group 13316\">\n" +
                                                  "<path id=\"Path_51\" data-name=\"Path 51\" d=\"M0,0H24V24H0Z\" ' opacity=\"0\"/>\n" +
                                                  "<path id=\"Path_52\" class="svg-primary-color" data-name=\"Path 52\" d=\"M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM10,17,5,12l1.41-1.41L10,14.17l7.59-7.59L19,8Z\" '/>\n" +
                                                "</g>\n" +
                                              "</g>\n" +
                                            "</svg>`;
    }
};



// WEBPACK FOOTER //
// ./src/common/plugins/svg/CheckBoxPlugin.js